import React from 'react'

function Footer() {
  return (
    <div className='w-full h-10 bg-white'>Footer</div>
  )
}

export default Footer